import { render, staticRenderFns } from "./AdminRequestUploadTicketDirectUpload.vue?vue&type=template&id=02bb9abc&scoped=true"
import script from "./AdminRequestUploadTicketDirectUpload.vue?vue&type=script&lang=js"
export * from "./AdminRequestUploadTicketDirectUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02bb9abc",
  null
  
)

export default component.exports